import Carousel from "../../bundles/LoggedInHomePage/components/Carousel";
import PropTypes from "prop-types";
import React from "react";

const imageUrlPrefix = "https://karat-herokuapp-com.freetls.fastly.net/s3media";

const MarketingAssets = ({marketingAssets}) => (
  <div className="marketing-assets">
    <div className="desktop-only mb50">
      {
        marketingAssets.map(marketingAsset =>
          <a
            className="image-link"
            href={marketingAsset.link_url}
            key={`marketing-asset-${marketingAsset.id}`}
          >
            <img
              className="thirds mh8 wishlist-link-recently-added"
              src={`${imageUrlPrefix}${marketingAsset.image_url}`}
            />
          </a>)
      }
    </div>
    <div className="mobile-only">
      <Carousel marketingAssets={marketingAssets} />
    </div>
  </div>
);

export default MarketingAssets;

MarketingAssets.propTypes = {"marketingAssets": PropTypes.array};
MarketingAssets.defaultProps = {"marketingAssets": []};
